var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcrobatReader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.623,
    height: 14.6,
    viewBox: "0 0 14.623 14.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_acrobat_reader",
    "data-name": "icona acrobat_reader",
    d: "M13.787,9.008a3.421,3.421,0,0,0-2.468-.7,12,12,0,0,0-2.2.217A11.854,11.854,0,0,1,7.775,6.932a13.721,13.721,0,0,1-.83-1.34,12.528,12.528,0,0,0,.7-3.57c0-.979-.352-2-1.367-2a.954.954,0,0,0-.789.468c-.457.824-.251,2.63.536,4.413-.294.89-.6,1.74-.993,2.7C4.7,8.4,4.31,9.234,3.913,10c-2.281.927-3.757,2.01-3.9,2.859a.943.943,0,0,0,.267.849,1.308,1.308,0,0,0,.865.319c1.513,0,3.108-2.505,3.918-4.015.622-.211,1.244-.4,1.865-.594.682-.189,1.367-.341,1.989-.448a5.586,5.586,0,0,0,3.715,1.7c.872,0,1.182-.361,1.287-.657a1.014,1.014,0,0,0-.147-1.018l.012.023Zm-.809.617a.744.744,0,0,1-.81.53,2.088,2.088,0,0,1-.352-.042,5.413,5.413,0,0,1-2.28-1.233,10.335,10.335,0,0,1,1.741-.146,4.648,4.648,0,0,1,1.057.084c.286.062.742.255.64.808h.012Zm-4.4-1c-.537.111-1.118.242-1.72.406-.477.131-.973.277-1.472.451.271-.528.5-1.038.706-1.523.25-.6.456-1.212.663-1.783.2.357.432.72.66,1.042A16.134,16.134,0,0,0,8.577,8.634V8.623ZM5.866.734a.454.454,0,0,1,.4-.255c.435,0,.518.508.518.913A11.384,11.384,0,0,1,6.22,4.3C5.6,2.648,5.557,1.267,5.868.734Zm-2.28,9.89C2.529,12.4,1.514,13.51.892,13.51a.506.506,0,0,1-.31-.107.456.456,0,0,1-.145-.445c.124-.638,1.306-1.529,3.15-2.335Z",
    transform: "translate(0.301 0.277)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcrobatReader);
export default __webpack_public_path__ + "static/media/acrobat_reader.0bc023bdb903cf78962d3c8a3c473301.svg";
export { ForwardRef as ReactComponent };